import Cookies from 'universal-cookie';
const cookies = new Cookies();
const logout = async () => {
  cookies.set('access_token', '', { path: '/' });
  window.location.href = window.location.origin + '/authorization';
};

export default logout;
